/*
 This file is added in the Views via prebuild.ps1 file.
 */

namespace Dataport.OD.ErAnMiZuWohngeld {
  export const disabledAttr = 'disabled';
  export const requiredAttr = 'required';

  export enum Citizenship {
    NoSelection = '910',
    NoCitizenship = '997',
    Undefined = '998',
    NoInformation = '999',
    German = '000',
    Swiss = '158',
  }

  export enum CivilStatus {
    Single = '001',
    Married = '002',
    RegisteredPartnership = '005',
  }

  export enum AddressLocation {
    InsideGermany = '001',
    OutsideGermany = '002',
  }

  export enum DomesticAddress {
    StreetAddress = '001',
    PostboxAddress = '002',
  }

  export enum RadioButtonOptions {
    Yes = '01',
    No = '02',
  }

  export enum GeneralDropdownOptions {
    PleaseChoose = '',
    No = '001',
    Yes = '002',
    AnswerLater = '003',
    Sonstiges999 = '999',
    Sonstiges99 = '99',
  }

  export enum CenterOfLifeDropdownOptions {
    No = '01',
    Yes = '02',
  }

  export enum DateSelection {
    Requested = 1,
    Approved = 2,
    Omiteted = 3,
    Rejected = 4,
  }

  export enum DisabilityDegree {
    Option_10 = '010',
  }

  export enum HiddenFieldIsVisibleValue {
    True = 'true',
    False = 'false',
  }

  export enum DropdownListARepresentation {
    PleaseChoose = '',
    No = '001',
    LegalRepNaturalPerson = '002',
    LegalRepLegalEntity = '003',
    AuthRepNaturalPerson = '004',
    AuthRepLegalEntity = '005',
  }

  export enum AddressOptions {
    OptionStreetAddress = '001',
    OptionPostboxAddress = '002',
  }

  export enum IncomeDropdownOptions {
    Pension = '001',
    Salary = '002',
    Sonstiges = '999',
  }
  export enum AddressLocationOptions {
    AddressLocationInGermany = '001',
    AddressLocationOutsideGermany = '002',
  }

  export class Common {
    /**
     * Gets the value of the given radio button group
     *
     * @param selector selector for the field to change
     * @param card card, if field is part of a card, can be ommited
     * @returns
     */
    GetRadioButtonListValue(selector: string, card: JQuery<Element> | null = null): string | number | string[] {
      if (!selector) {
        return '';
      }

      if (card) {
        // ensure that selector ends with id for card
        if (selector.indexOf('#') >= 0) {
          selector = selector.replace('#', '[id$=');
          selector += ']';
        }
        return card.find(selector)?.find('input:checked')?.val() ?? '';
      }

      return $(selector)?.find('input:checked')?.val() ?? '';
    }

    SetFieldVisible(parent: JQuery<Element>, isVisible: boolean): void {
      if (isVisible) {
        parent.show();
      } else {
        parent.hide();
      }
    }

    SetFieldRequired(input: JQuery<Element>, isRequired: boolean): void {
      input.prop(requiredAttr, isRequired);
    }

    SetFieldDisabled(input: JQuery<Element>, isDisabled: boolean): void {
      const hasValElement = input.find('[id$=_val]').length > 0;

      if (hasValElement) {
        //radio button
        input.find('[id$=_Selected_radioButton]').each((i, e) => {
          $(e).prop(disabledAttr, isDisabled);
        });
        input.find('[id$=_val]').prop(disabledAttr, isDisabled);
      } else {
        input.prop(disabledAttr, isDisabled);
      }
    }

    ResetField(input: JQuery<Element>): void {
      const hasValElement = input.find('[id$=_val]').length > 0;

      if (hasValElement) {
        //radio button
        input.find('[id$=_Selected_radioButton]').each((i, e) => {
          $(e).prop('checked', false).trigger('change');
        });
        input.find('[id$=_val]').val('').trigger('change');
      } else {
        input.val('').trigger('change');
      }
    }

    ResetChangeState(): void {
      (Dataport.OD as any).CancelDialog.changeState = 'false';
    }

    GetIsCardVisibleHiddenValueForGeneralDropdownOptionYes(
      questionValue: string | undefined
    ): HiddenFieldIsVisibleValue {
      return questionValue && questionValue === GeneralDropdownOptions.Yes
        ? HiddenFieldIsVisibleValue.True
        : HiddenFieldIsVisibleValue.False;
    }

    SetHiddenField($hiddenField: JQuery<HTMLElement>, value: string): void {
      $($hiddenField).val(value);
      $($hiddenField).trigger('change');
    }

    GetHiddenField($hiddenField: JQuery<HTMLElement>): string | undefined {
      return $($hiddenField).val()?.toString();
    }

    GetCards(cardSelector: string): JQuery<HTMLElement> {
      return $(cardSelector).children().filter(`[class~='card-wrapper']:not(.removed)`);
    }

    HideFirstCardCloseButton($cards: JQuery<HTMLElement>, closeButtonSelector: string): void {
      const firstCard = $cards[0];

      if (firstCard) {
        $(firstCard).find(closeButtonSelector).hide();
      }
    }

    GetValueIfVisible(isCardVisibleValue: string | undefined, value: string): string {
      return isCardVisibleValue && isCardVisibleValue === HiddenFieldIsVisibleValue.True ? value : '';
    }

    DisplayFirstCard($cards: JQuery<Element>, addCardButtonSelector: string): void {
      if ($cards.length === 0) {
        let eventData: any = {
          currentTarget: addCardButtonSelector,
        };

        (Dataport.OD as any).AddContentButton.AddContent(eventData);
      }
    }

    ClearDatepicker($card: JQuery<Element>, selector: string): void {
      this.ResetField($($card).find(selector));
    }

    SelectRadioButtonInGroupByValue(groupSelector: string, value: string): void {
      const radioButtons = $(groupSelector).find('[id$=_Selected_radioButton]');
      radioButtons.each((_i, currentRadioButton) => {
        if ($(currentRadioButton).val() === value) {
          $(currentRadioButton).prop('checked', true).trigger('change');
        }
      });
    }

    AttachAjaxCompleteEvent(eventIdentifier: string, interceptedUrl: string, functionToExecute: () => void): void {
      const ajaxCompleteEventSelector = `ajaxComplete.${eventIdentifier}`;
      $(document)
        .off(ajaxCompleteEventSelector)
        .on(ajaxCompleteEventSelector, (_event, _xhr, settings) => {
          if (settings.url.includes(interceptedUrl)) {
            functionToExecute();
          }
        });
    }
  }

  export class CardList {
    private readonly $selector: string;
    private readonly $cardCountSelector: string;
    private readonly $addCardButtonSelector: string;
    private readonly $events: Array<any>;
    private isIntialized: boolean = false;
    private readonly reference;
    private canDeleteFirstCard = false;
    public cards: Array<any> = [];

    public $CloseButtonSelector: string = '.close';
    public $CardWrapperSelector: string = 'card-wrapper';

    constructor(
      $selector: string,
      $cardCountSelector: string,
      $addCardButtonSelector: string,
      $events: Array<any>,
      reference
    ) {
      this.$selector = $selector;
      this.$cardCountSelector = $cardCountSelector;
      this.$addCardButtonSelector = $addCardButtonSelector;
      this.$events = $events;
      this.reference = reference;

      this.InitializeCards();
      this.OnAddCard();
    }

    InitCards(): void {
      this.DisplayFirstCard();

      let $cards = this.GetAllDisplayedCards();

      this.StoreAndInitializeCards($cards);
      this.HideFirstCardCloseButton();
    }

    GetAllDisplayedCards(): JQuery<any> {
      let $cards = $(this.$selector).children().filter(`[class~='${this.$CardWrapperSelector}']`);

      return $cards;
    }

    StoreAndInitializeCards($cards): void {
      $cards.each((index, item) => {
        this.AddNewCard($(item), index);
      });
    }

    DisplayFirstCard(): void {
      if (this.cards.length === 0 && this.isIntialized === false) {
        let eventData: any = {
          currentTarget: this.$addCardButtonSelector,
        };

        (Dataport.OD as any).AddContentButton.AddContent(eventData);
      }
      this.isIntialized = true;
    }

    OnAddCard(): void {
      if (!this.isIntialized) {
        $(document).ajaxComplete(() => {
          this.InitializeCards();
        });
      }
    }

    InitializeCards(): void {
      let $cards = this.GetAllDisplayedCards();
      this.StoreAndInitializeCards($cards);
      this.HideFirstCardCloseButton();
    }

    AddNewCard($card: JQuery<Element>, index: number): void {
      if (!this.cards[index]) {
        this.cards.push($card);
        this.AttachEvents(this.cards[index], index);
      }
    }

    RemoveCards(): void {
      for (let i in this.cards) {
        $(this.cards[i]).remove();
      }

      this.SetCardHiddenInput();

      this.cards = [];
      this.isIntialized = false;
    }

    SetCardHiddenInput(): void {
      $(this.$cardCountSelector).val(0);
    }

    HideFirstCardCloseButton(): void {
      if (this.cards[0]) {
        if (!this.canDeleteFirstCard) {
          let $first = this.cards[0];
          $first.find(this.$CloseButtonSelector).hide();
        }
      }
    }

    AttachEvents($card: JQuery<Element>, index: number): void {
      for (let i in this.$events) {
        this.$events[i].apply(this.reference, [$card, index]);
      }
    }

    CanDeleteFirstCardElement(canDelete: boolean) {
      this.canDeleteFirstCard = canDelete;
    }
  }

  type AddressFields = {
    AddressLocationValueSelector: string;
    DomesticAddressTypeValueSelector: string;

    DomesticAddressStreetAddressStreetSelector: string;
    DomesticAddressStreetAddressNumberSelector: string;
    DomesticAddressStreetAddressPostalCodeSelector: string;
    DomesticAddressStreetAddressCitySelector: string;
    DomesticAddressStreetAddressExtensionSelector: string;

    DomesticAddressPostOfficeBoxAddressPostOfficeBoxSelector: string;
    DomesticAddressPostOfficeBoxAddressPostalCodeSelector: string;
    DomesticAddressPostOfficeBoxAddressCitySelector: string;

    ForeignAddressStateSelector: string;
    ForeignAddressLine1Selector: string;
    ForeignAddressLine2Selector: string;
    ForeignAddressLine3Selector: string;
    ForeignAddressLine4Selector: string;
    ForeignAddressLine5Selector: string;
  };

  export class AddressArea {
    private readonly common: Common;
    private readonly addressFieldSelectors: AddressFields;
    private readonly formSelector: string;

    constructor(common: Common, addressFields: AddressFields, formSelector: string) {
      this.common = common;
      this.addressFieldSelectors = addressFields;
      this.formSelector = formSelector;
    }

    AttachSubmitEventHandler(): void {
      const form = $(this.formSelector);
      const wizardStepId = form.parent().prop('data-step-id');
      const submitEventSelector = `submit.${wizardStepId}`;

      form.off(submitEventSelector).on(submitEventSelector, () => {
        this.HandleSubmitEvent();
      });
    }

    private HandleSubmitEvent(): void {
      const { AddressLocationValueSelector, DomesticAddressTypeValueSelector } = this.addressFieldSelectors;
      const addressLocation = $(AddressLocationValueSelector).val();

      if (addressLocation === AddressLocation.InsideGermany) {
        const addressType = $(DomesticAddressTypeValueSelector).val();

        this.ResetForeignAddressFields();
        if (addressType == DomesticAddress.StreetAddress) {
          this.ResetDomesticAddressFieldsPostOfficeBox();
        } else if (addressType == DomesticAddress.PostboxAddress) {
          this.ResetDomesticAddressFieldsStreetAddress();
        }
      } else if (addressLocation == AddressLocation.OutsideGermany) {
        this.ResetDomesticAddressFieldsPostOfficeBox();
        this.ResetDomesticAddressFieldsStreetAddress();
        this.ResetDomesticAddressType(DomesticAddressTypeValueSelector);
      }
    }

    ResetAllAddressFields(): void {
      this.ResetForeignAddressFields();
      this.ResetDomesticAddressFieldsPostOfficeBox();
      this.ResetDomesticAddressFieldsStreetAddress();

      const { DomesticAddressTypeValueSelector } = this.addressFieldSelectors;
      this.ResetDomesticAddressType(DomesticAddressTypeValueSelector);
      const { AddressLocationValueSelector } = this.addressFieldSelectors;
      this.ResetAddressLocation(AddressLocationValueSelector);
    }

    ResetForeignAddressFields(): void {
      const {
        ForeignAddressStateSelector,
        ForeignAddressLine1Selector,
        ForeignAddressLine2Selector,
        ForeignAddressLine3Selector,
        ForeignAddressLine4Selector,
        ForeignAddressLine5Selector,
      } = this.addressFieldSelectors;

      this.common.ResetField($(ForeignAddressStateSelector));
      this.common.ResetField($(ForeignAddressLine1Selector));
      this.common.ResetField($(ForeignAddressLine2Selector));
      this.common.ResetField($(ForeignAddressLine3Selector));
      this.common.ResetField($(ForeignAddressLine4Selector));
      this.common.ResetField($(ForeignAddressLine5Selector));
    }

    ResetAddressLocation(addressLocationValueSelector: string): void {
      const addressLocationSelector = addressLocationValueSelector.replace('_val', '');
      this.common.ResetField($(addressLocationSelector));
    }

    ResetDomesticAddressType(domesticAddressTypeValueSelector: string): void {
      const domesticAddressTypeSelector = domesticAddressTypeValueSelector.replace('_val', '');
      this.common.ResetField($(domesticAddressTypeSelector));
    }

    ResetDomesticAddressFieldsPostOfficeBox(): void {
      const {
        DomesticAddressPostOfficeBoxAddressPostOfficeBoxSelector,
        DomesticAddressPostOfficeBoxAddressPostalCodeSelector,
        DomesticAddressPostOfficeBoxAddressCitySelector,
      } = this.addressFieldSelectors;

      this.common.ResetField($(DomesticAddressPostOfficeBoxAddressPostOfficeBoxSelector));
      this.common.ResetField($(DomesticAddressPostOfficeBoxAddressPostalCodeSelector));
      this.common.ResetField($(DomesticAddressPostOfficeBoxAddressCitySelector));
    }

    ResetDomesticAddressFieldsStreetAddress(): void {
      const {
        DomesticAddressStreetAddressStreetSelector,
        DomesticAddressStreetAddressNumberSelector,
        DomesticAddressStreetAddressPostalCodeSelector,
        DomesticAddressStreetAddressCitySelector,
        DomesticAddressStreetAddressExtensionSelector,
      } = this.addressFieldSelectors;

      this.common.ResetField($(DomesticAddressStreetAddressStreetSelector));
      this.common.ResetField($(DomesticAddressStreetAddressNumberSelector));
      this.common.ResetField($(DomesticAddressStreetAddressPostalCodeSelector));
      this.common.ResetField($(DomesticAddressStreetAddressCitySelector));
      this.common.ResetField($(DomesticAddressStreetAddressExtensionSelector));
    }
  }
}
